import { useEffect, useState } from "react";
import { onCategoryConfigChange } from "../utils/carCategory";

/**
 * Redraw when the admin's category rules change.
 *
 * detectCarCategory and resolveShortName read module state that is filled in from the
 * network after the first render. React cannot see that state, so a page that had
 * already drawn kept showing the category it was drawn with — an admin who mapped a
 * model watched the car carry on as a MINI SUV and reasonably concluded the save had
 * not worked. It had; nothing had asked the page to look again.
 *
 * Returns a counter that changes on every reload, so it can also be used as an effect
 * dependency where a value needs recomputing rather than merely re-rendering.
 */
export function useCategoryConfig() {
  const [version, setVersion] = useState(0);
  useEffect(() => onCategoryConfigChange(() => setVersion((v) => v + 1)), []);
  return version;
}
